/**
 * @param {Function} hitAxios
 * @param {File} file
 * @param {{ title?: string, onUploadProgress?: (e: { loaded: number; total?: number }) => void }} [opts]
 */
export async function uploadVideoToLibrary(hitAxios, file, opts = {}) {
  const fd = new FormData();
  fd.append("video", file);
  if (opts.title?.trim()) {
    fd.append("title", opts.title.trim());
  }

  const res = await hitAxios({
    path: "/api/video-studio/jobs/upload",
    post: true,
    obj: fd,
    showLoading: false,
    showSnackbar: false,
    timeout: 600000,
    onUploadProgress: opts.onUploadProgress,
  });

  if (res?.logout) {
    throw new Error("Session expired. Please sign in again.");
  }
  if (!res?.data?.success) {
    throw new Error(res?.data?.msg || "Could not upload video.");
  }

  const job = res.data.data?.job;
  if (!job?.id) {
    throw new Error("Server did not return the uploaded video.");
  }
  return job;
}
